import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const loadComputerTaskPage = async () => {
    const { ComputerTaskPage } = await import('#pplx/frontend/apps/ask/spa/ComputerTaskPage.js');
    return { default: ComputerTaskPage };
};
const ComputerTaskPagePreloader = Dynamic(loadComputerTaskPage);
export const preloadComputerTaskPage = ComputerTaskPagePreloader.preload;
//# sourceMappingURL=ComputerTaskPageRouteShared.js.map